import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import {
  Button,
} from '@material-ui/core'

import ConfirmationDialog from '../controls/ConfirmationDialog'

import * as DeviceActionCreators from '../../actions/device'
import * as TimeseriesActionCreators from '../../actions/timeseries'
import * as UnitActionCreators from '../../actions/unit'

class UnitControlContainer extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    unitId: PropTypes.number.isRequired,
    /* mapped state */
    timeseries: PropTypes.object.isRequired,
    timeseriesByUnit: PropTypes.object.isRequired,
    uiConfig: PropTypes.object.isRequired,
    /* mapped dispatch */
    unitActions: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
  }

  static styles = () => ({
  })

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
      timeseriesByUnit: state.timeseriesByUnit,
      uiConfig: state.uiConfig,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      unitActions: bindActionCreators(UnitActionCreators, dispatch),
      deviceActions: bindActionCreators(DeviceActionCreators, dispatch),
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  state = {
    showWaterOffConfirmation: false,
    showWaterOnConfirmation: false,
  }

  componentDidMount() {
    this.props.timeseriesActions.listUnitTimeseries(this.props.unitId)
    this.props.unitActions.listUnitDevices(this.props.unitId)
  }

  activateWaterRelay = (val) => {
    this.props.deviceActions.executeCommand(this.waterDeviceId(), 'set_relay', {
      relay: { type: 'int', value: val },
      state: { type: 'bool', value: true },
      duration: { type: 'int', value: 10 },
    })
  }

  onWaterOn = () => {
    this.activateWaterRelay(0)
    this.handleConfirmationClose()
  }

  onWaterOff = () => {
    this.activateWaterRelay(1)
    this.handleConfirmationClose()
  }

  handleWaterOnConfirmationShow = () => {
    this.setState({ showWaterOnConfirmation: true })
  }

  handleWaterOffConfirmationShow = () => {
    this.setState({ showWaterOffConfirmation: true })
  }

  handleConfirmationClose = () => {
    this.setState({
      showWaterOffConfirmation: false,
      showWaterOnConfirmation: false,
    })
  }

  unitTimeseries() {
    const {
      unitId, timeseries, timeseriesByUnit,
    } = this.props
    const tsIds = timeseriesByUnit[unitId] || []
    return tsIds.map((tsId) => timeseries[tsId])
  }

  waterOnStatusTimeseries() {
    return this.unitTimeseries().find((ts) => (
      ts.name === 'water/open'
    ))
  }

  waterOffStatusTimeseries() {
    return this.unitTimeseries().find((ts) => (
      ts.name === 'water/closed'
    ))
  }

  waterOn() {
    const on = this.waterOnStatusTimeseries()
    if (on) {
      return on.current_value.value
    }
    const off = this.waterOffStatusTimeseries()
    if (off) {
      return !off.current_value.value
    }
    return false
  }

  waterOff() {
    const off = this.waterOffStatusTimeseries()
    if (off) {
      return off.current_value.value
    }
    const on = this.waterOnStatusTimeseries()
    if (on) {
      return !on.current_value.value
    }
    return false
  }

  waterDeviceId() {
    const ts = this.waterOnStatusTimeseries() || this.waterOffStatusTimeseries() || {}
    return ts.device_id
  }

  render() {
    if (this.props.uiConfig.showUnitControlUI) {
      return (
        <>
          {this.waterDeviceId() && !this.waterOn()
            && <Button onClick={this.handleWaterOnConfirmationShow}>Turn Water On</Button>}
          {this.state.showWaterOffConfirmation
            && (
              <ConfirmationDialog
                open
                title="Confirm Turning Off Water"
                description="Are you sure you want to turn off the water?"
                confirmText="Turn off"
                onCancel={this.handleConfirmationClose}
                onConfirm={this.onWaterOff}
              />
            )}
          {this.waterDeviceId() && !this.waterOff()
            && <Button onClick={this.handleWaterOffConfirmationShow}>Turn Water Off</Button>}
          {this.state.showWaterOnConfirmation
            && (
            <ConfirmationDialog
              open
              title="Confirm Turning On Water"
              description="Are you sure you want to turn on the water?"
              confirmText="Turn on"
              onCancel={this.handleConfirmationClose}
              onConfirm={this.onWaterOn}
            />
            )}
        </>
      )
    }

    return null
  }
}

export default connect(
  UnitControlContainer.mapStateToProps,
  UnitControlContainer.mapDispatchToProps,
)(withStyles(UnitControlContainer.styles)(UnitControlContainer))
